import { useEffect, useRef, useState } from 'react';
import { Sheet } from './Sheet';
import { useUser } from '../app/session';
import '../styles/profile-photo.css';

const key = (id: string) => `jungles.demo-pro.v1:${id}`;
export function readDemoPro(id: string): boolean {
  try { return localStorage.getItem(key(id)) === 'enabled'; } catch { return false; }
}
export function DemoPro({ onClose, onEnabled }: { onClose: () => void; onEnabled: () => void }) {
  const user = useUser();
  const [error, setError] = useState('');
  const panel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const buttons = () => Array.from(panel.current?.querySelectorAll<HTMLButtonElement>('button:not(:disabled)') ?? []);
    buttons()[0]?.focus();
    const trap = (event: KeyboardEvent) => {
      if (event.key !== 'Tab') return;
      const items = buttons(); const first = items[0]; const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.current?.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !panel.current?.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    };
    document.addEventListener('keydown', trap);
    return () => { document.removeEventListener('keydown', trap); previous?.focus(); };
  }, []);
  const enable = () => {
    try { localStorage.setItem(key(user.id), 'enabled'); onEnabled(); }
    catch { setError('Не удалось сохранить демо на устройстве. Разрешите локальное хранение и повторите.'); }
  };
  return <Sheet title="Jungles Pro · демо" onClose={onClose}>
    <div className="demo-paywall" ref={panel}>
      <img className="pro-art" src="/assets/ui/points-diamond-bicep.webp" alt="" />
      <h1>Считайте КБЖУ<br />по одному фото</h1>
      <p>Фото блюда — приблизительная оценка калорий и БЖУ. Все значения можно исправить перед добавлением.</p>
      <div className="demo-disclosure"><b>Бесплатный деморежим</b><p>Без оплаты, подписки и автопродления. Включается только для этого аккаунта в этом браузере. Это не платный доступ; распознавание зависит от доступности сервиса.</p></div>
      {error && <p role="alert">{error}</p>}
      <button className="b p wide" onClick={enable}>Включить демо бесплатно</button>
      <button className="b ghost wide" onClick={onClose}>Не сейчас</button>
    </div>
  </Sheet>;
}
